import { styled, Grid } from '@material-ui/core'

const LEFT_MENU_WIDTH = 80

export const Wrapper = styled(Grid)(({ theme }) => ({
  alignSelf: 'stretch',
  backgroundColor: theme.palette.background.default,
  width: LEFT_MENU_WIDTH,
}))
